<div [class.ourAppEvent]=ourAppEvent>
    <our-app *ngIf="ourAppEvent"></our-app>
    <div class="pages">
        <router-outlet></router-outlet>
    </div>
</div>
<ng-template #template>
    <div class="modal-header">
        <h5 class="modal-title pull-left" *ngIf="alerts.length == 1">Message important</h5>
        <h5 class="modal-title pull-left" *ngIf="alerts.length > 1">Messages importants</h5>
        <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <ul class="no-padding-ul">
            <li class="no-padding" *ngFor="let alert of alerts" [innerHtml]="alert | safeHtml"></li>
        </ul>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="bsModalRef.hide()">Ok</button>
    </div>
</ng-template>